var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphViewBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V6.81818H6.81818V0H0ZM5.87327 5.87327H0.944911V0.944911H5.87327V5.87327Z",
    fill: "#09a75e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 0V6.81818H15V0H8.18182ZM14.0551 5.87327H9.12673V0.944911H14.0551V5.87327Z",
    fill: "#09a75e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.18176V14.9999H6.81818V8.18176H0ZM5.87327 14.055H0.944911V9.12667H5.87327V14.055Z",
    fill: "#09a75e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 8.18176V14.9999H15V8.18176H8.18182ZM14.0551 14.055H9.12673V9.12667H14.0551V14.055Z",
    fill: "#09a75e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphViewBtn);
export default __webpack_public_path__ + "static/media/graph-view-btn.3b443b81c2083c144a64ec28a3887585.svg";
export { ForwardRef as ReactComponent };